<div
  class="form-group mb-0"
  [ngClass]="{ 'mb-0': noMarginBottom }"
  [ngStyle]="{ 'min-width.px': minWidthPx, 'max-width.px': maxWidthPx }"
>
  <label class="d-flex justify-content-between" *ngIf="label && label.length > 0">{{ label | translate }}:</label>
  <label class="float-right required" *ngIf="required">
    ({{ 'required' | translate }})
  </label>
  <div class="input-group">
    <input
      [ngClass]="{'is-invalid' : requiredCssClass || showErrorBorder}"
      class="form-control text-right"
      type="number"
      [ngModel]="model"
      (ngModelChange)="onNgModelChange($event)"
      [readonly]="readonly"
      [disabled]="readonly"
      data-cy="product-amount-input"
      (keypress)="checkCharacter($event)"
    />
    <div class="input-group-append bg-primary" *ngIf="!readonly">
      <div>
        <div
          class="d-flex justify-content-center"
          (click)="addOne()"
          style="width: 35px; height: 18px"
          data-cy="increment"
        >
          <div class="far fa-plus my-auto"></div>
        </div>
        <div class="d-flex justify-content-center" (click)="deductOne()" style="width: 35px; height: 18px">
          <div class="far fa-minus my-auto"></div>
        </div>
      </div>
    </div>
  </div>
</div>
